/* eslint-disable jsx-a11y/no-static-element-interactions */
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import CountryPicker from 'react-phone-input-2'
import 'react-phone-input-2/lib/high-res.css'
import { InputText } from 'ui_kit_qmd'
import './PhoneInput.scss'
import ArrowImg from '../../images/charts/backArrow.png'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

const countryPickerButtonStyle = {
  border: 'none',
  borderRadius: '4px 0 0 4px',
  background: '#eff3f6',
}

const textInputStyle = {
  borderRadius: '0 4px 4px 0',
}

const inputTextWrapperStyle = {
  width: '100%',
}

export const PhoneInput = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    id,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    inputLabel,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    disabled,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    error,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    loading,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setCountryCode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsPhoneCorrect,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    phoneCountryCode = '1',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    phoneNumber,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    phoneCountry = 'us',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onChangeCountry,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onChangeNumber,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    checkPhone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isPhoneCorrect,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isOldNumberCorrect,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isSuccess,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setPhoneError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsPhoneValidationStarted,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isResetEmergencyContact,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isInitialEmergencyNumber,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    className = '',
  }) => {
    const [isFirstRender, setIsFirstRender] = useState(true)
    const [buttonWidth, setButtonWidth] = useState(null)
    const [oldNumber, setOldNumber] = useState(phoneNumber)
    const [phoneInputMainWrapperWidth, setPhoneInputMainWrapperWidth] = useState(0)
    const [localInputError, setLocalInputError] = useState('')
    const [isBlurred, setBlurred] = useState(false)

    useEffect(() => {
      const phoneInputElement = document.getElementById(id)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const arrow = phoneInputElement.querySelector('.arrow')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const formControl = phoneInputElement.querySelector('.form-control')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const selectedFlag = phoneInputElement.querySelector('.selected-flag')

      const countryCode = document.createElement('span')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const text = document.createTextNode(`+${formControl.value.slice(1)}`)
      countryCode.classList.add('phone-input-country-code')
      countryCode.appendChild(text)

      const arrowImg = document.createElement('img')
      arrowImg.src = ArrowImg
      arrowImg.classList.add('phone-input-country-button-arrow')

      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      arrow.appendChild(arrowImg)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      selectedFlag.appendChild(countryCode)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      selectedFlag.onmouseover = function () {
        // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
        this.style.backgroundColor = 'transparent'
      }

      window.onresize = () => {
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        setPhoneInputMainWrapperWidth(phoneInputElement.clientWidth)
      }

      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      setPhoneInputMainWrapperWidth(phoneInputElement.clientWidth)

      if (!disabled) {
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        setCountryCode(formControl.value.slice(1))
      }

      setIsFirstRender(false)

      return () => {
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        selectedFlag.onmouseover = null
        window.onresize = () => {}
      }
    }, [])

    useEffect(() => {
      const phoneInputElement = document.getElementById(id)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const coutryCode = phoneInputElement.querySelector('.phone-input-country-code')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const button = phoneInputElement.querySelector('.react-tel-input .selected-flag')
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const arrow = phoneInputElement.querySelector('.react-tel-input .selected-flag .arrow')

      const computedButtonWidth = phoneCountryCode.length * 12 + 75
      const computedArrowMargin = phoneCountryCode.length * 12 + 15

      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      coutryCode.innerHTML = `+${phoneCountryCode}`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      button.style.width = `${computedButtonWidth}px`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      arrow.style.marginLeft = `${computedArrowMargin}px`
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setButtonWidth(computedButtonWidth)
    }, [phoneCountryCode])

    useEffect(() => {
      if (!isInitialEmergencyNumber) {
        if (
          phoneNumber === oldNumber &&
          !isOldNumberCorrect &&
          isOldNumberCorrect !== '' &&
          !loading &&
          !isResetEmergencyContact
        ) {
          setLocalInputError(
            getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, inputLabel.replaceAll('*', '').toLowerCase()),
          )
        } else {
          setLocalInputError('')
        }
      }
    }, [phoneNumber, isOldNumberCorrect])

    useEffect(() => {
      if (!disabled) {
        setPhoneError(localInputError)
      }
    }, [localInputError])

    const onFocusCountryPicker = useCallback(() => {
      const phoneInputElement = document.getElementById(id)
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      const searchContainer = phoneInputElement.querySelector('.search')
      const searchBox = searchContainer?.querySelector('.search-box')
      const clearButtonContainer = document.createElement('div')
      clearButtonContainer.classList.add('search-country-clear-button-container')
      clearButtonContainer.style.right = `${
        ((searchContainer?.clientWidth || 0) - (searchBox?.clientWidth || 0)) / 2
      }px`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      clearButtonContainer.addEventListener('click', () => phoneInputElement.querySelector('.search-box').focus())
      searchContainer?.appendChild(clearButtonContainer)
    }, [])

    useEffect(() => {
      // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
      let timeout

      if (isBlurred) {
        if (phoneNumber === oldNumber) {
          if (isOldNumberCorrect) {
            setIsPhoneCorrect(true)
          } else {
            setIsPhoneCorrect(false)
          }
        }
        timeout = setTimeout(() => {
          if (phoneNumber && phoneNumber !== oldNumber) {
            setIsPhoneValidationStarted(true)

            setOldNumber(phoneNumber)
            checkPhone()
          }
          setBlurred(false)
        }, 150)
      }

      return () => {
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        if (timeout) {
          clearTimeout(timeout)
          setBlurred(false)
        }
      }
    }, [isBlurred])

    const onBlur = () => {
      setBlurred(true)
    }

    const onChangeCountryAction = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (code, country) => {
        setLocalInputError('')
        onChangeCountry(code, country)
      },
      [onChangeCountry],
    )

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onChangedNumberValue = (value) => {
      setLocalInputError('')
      onChangeNumber(value)
    }

    const countryPickerContainerStyle = useMemo(
      () => ({
        width: 'max-content',
        opacity: isFirstRender ? 0 : 1,
      }),
      [isFirstRender],
    )

    const countryPickerInputStyle = useMemo(
      () => ({
        width: buttonWidth,
        height: 60,
        border: 'none',
        borderRadius: 0,
        background: 'transparent',
        paddingLeft: 0,
        color: 'transparent',
      }),
      [buttonWidth],
    )

    const countryPickerDropdownStyle = useMemo(
      () => ({
        background: '#eff3f6',
        fontFamily: 'Helvetica',
        fontWeight: '400',
        fontSize: 16,
        width: phoneInputMainWrapperWidth,
      }),
      [phoneInputMainWrapperWidth],
    )

    return (
      <div id={id} className={`phone-input-main-wrapper${className ? ` ${className}` : ''}`}>
        <div
          className={`phone-input-container${disabled ? 'phone-input-container--disabled' : ''}${error ? 'error' : ''}`}
          onKeyDown={onFocusCountryPicker}>
          <CountryPicker
            country={phoneCountry}
            enableSearch
            containerStyle={countryPickerContainerStyle}
            searchPlaceholder='Search'
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            inputStyle={countryPickerInputStyle}
            buttonStyle={countryPickerButtonStyle}
            dropdownStyle={countryPickerDropdownStyle}
            buttonClass='phone-input-country-button'
            onChange={onChangeCountryAction}
            disabled={disabled}
          />
          <form autoComplete='off' style={inputTextWrapperStyle}>
            <InputText
              containerStyle={textInputStyle}
              label={inputLabel}
              view='visitType'
              setValue={onChangedNumberValue}
              onUserBlur={onBlur}
              isError={!disabled && (error || localInputError)}
              success={
                !disabled &&
                (isSuccess || isPhoneCorrect || (phoneNumber === oldNumber && isOldNumberCorrect && !loading && !error))
              }
              value={phoneNumber}
              disabled={disabled}
              isDisableAutocomplete
            />
          </form>
        </div>
        {(error || localInputError) && !disabled && !isResetEmergencyContact ?
          <div className='phone-input-local-error-label'>{error || localInputError}</div>
        : null}
      </div>
    )
  },
)
